require('./polyfill');

// Global css for normalizing styles across browser
require('assets/normalize.css');
require('assets/custom.css');
require('assets/autofill.css');

import Cookies from 'js-cookie';

import { initApp } from 'app/enrollment';

import { FIRST_PAGE_VIEWED } from 'consts/storageConsts';

import { initOptimizely } from 'optimizely';

import { persistedStore } from 'store';

import { initDatadogRum } from 'utils/datadog';
import detectAutofill from 'utils/detectAutofill';
import { fetchAndStoreVariants, initExPlat } from 'utils/explat';
import { initLogging } from 'utils/logger/loggerHelper';
import { IS_PRELOAD } from 'utils/queryParamHelpers';
import { initSegment } from 'utils/segment/initialize';
import { firstPageView } from 'utils/segment/pageEvents';
import cookies from 'utils/storage/cookies';
import convertQspsToCookies from 'utils/storage/qspToCookie';
import { unemploymentRedirect } from 'utils/unemployment-redirect';

// Clean up legacy deviceData cookies that may cause 400 errors
// See incident ir-0924-billowing-topaz
Cookies.remove('deviceData');

convertQspsToCookies();

unemploymentRedirect();
initLogging();
initDatadogRum();
initExPlat();

initSegment()
  .then(async anonymousId => {
    await fetchAndStoreVariants({
      unitId: anonymousId,
      isAnonymousId: true,
    });
  })
  .then(async () => {
    // userId might exist if user re-enters enrollment before session expires
    const persistedUserId = persistedStore?.getState()?.user?.userId;
    if (persistedUserId) {
      await fetchAndStoreVariants({
        unitId: persistedUserId,
        isAnonymousId: false,
      });
    }
  })
  .then(initOptimizely)
  .then(optimizelyClient => {
    if (!IS_PRELOAD) {
      if (cookies.get(FIRST_PAGE_VIEWED) !== 'true') {
        firstPageView();
        // Setting cookie with "0" so it expires as soon as user quits browser session
        const expirationDuration = 0;
        cookies.set(FIRST_PAGE_VIEWED, true, expirationDuration);
      }
      detectAutofill();
    }

    initApp({ optimizelyClient });
  });
